import { IAssignee, IProject, IProjectDb, ITrainCreateRequestValues } from '@relab/alstom-ptw-shared';

import { ActionType, AppActionTypes } from '../types';

export function projectCreateAction(project: IProjectDb): AppActionTypes {
  return {
    type: ActionType.PROJECT_CREATE,
    payload: {
      request: {
        url: '/project',
        method: 'post',
        data: {
          ...project,
        },
      },
    },
  };
}

export function projectAction(projectId: string): AppActionTypes {
  return {
    type: ActionType.PROJECT,
    payload: {
      request: {
        url: `/project/${projectId}`,
        method: 'get',
      },
    },
  };
}

export function projectsAction(): AppActionTypes {
  return {
    type: ActionType.PROJECTS,
    payload: {
      request: {
        url: '/projects',
        method: 'get',
      },
    },
  };
}

export function projectUpsertAction(params: IProject): AppActionTypes {
  return {
    type: ActionType.PROJECT_UPSERT,
    payload: {
      project: params,
    },
  };
}

export function projectDeleteAction(projectId: string): AppActionTypes {
  return {
    type: ActionType.PROJECT_DELETE,
    payload: {
      request: {
        url: `/project/${projectId}`,
        method: 'delete',
      },
      project: {
        _id: projectId,
      },
    },
  };
}

export function assigneeAddAction(projectId: string, assignee: IAssignee): AppActionTypes {
  return {
    type: ActionType.ASSIGNEE_ADD,
    payload: {
      request: {
        url: `/project/${projectId}/assignee`,
        method: 'post',
        data: {
          ...assignee,
        },
      },
    },
  };
}

export function assigneeRemoveAction(projectId: string, assigneeId: string): AppActionTypes {
  return {
    type: ActionType.ASSIGNEE_REMOVE,
    payload: {
      request: {
        url: `/project/${projectId}/assignee/${assigneeId}`,
        method: 'delete',
      },
      projectId,
      assigneeId,
    },
  };
}

export function trainCreateAction(projectId: string, train: ITrainCreateRequestValues): AppActionTypes {
  return {
    type: ActionType.TRAIN_CREATE,
    payload: {
      request: {
        url: `/project/${projectId}/train`,
        method: 'post',
        data: {
          ...train,
        },
      },
    },
  };
}

export function trainDeleteAction(projectId: string, trainId: string): AppActionTypes {
  return {
    type: ActionType.TRAIN_DELETE,
    payload: {
      request: {
        url: `/project/${projectId}/train/${trainId}`,
        method: 'delete',
      },
      projectId,
      trainId,
    },
  };
}
